module.exports = __webpack_public_path__ + "img/mobile.4fd702b5.svg";